import { useSelector } from 'react-redux';
import { AMENITIES_MAP } from 'consts';
import PerfectScrollbar from 'react-perfect-scrollbar';

import './styles.scss';
import { useWorldActions } from 'components/World/hooks/useWorldActions';
import { CloseIcon, GalleryIcon } from 'assets/icons';
import { useState, useRef, useEffect } from 'react';
import ChervonDown from 'containers/menu/panoMenu/iconArrow/ChervonDown';

const hiddenScene = ['6903592c085ec50c650870ca', '68fb0303e62230d4b4454459'];

export const AmenitiesOverview = () => {
  const { selectSceneById } = useWorldActions();
  const { scenes, worldParams } = useSelector((state) => state);
  const { sceneId } = worldParams;

  const amenitiesScenes = scenes.filter(
    (scene) => scene.groupId === 'amenities' && !hiddenScene.includes(scene._id)
  );

  const scrollbarRef = useRef();

  const [isScrollbarVisible, setIsScrollbarVisible] = useState(false);
  const [isOpen, setIsOpen] = useState(true);
  const [isMounted, setIsMounted] = useState(false);

  const isAmenityScene = AMENITIES_MAP[sceneId] !== undefined;

  useEffect(() => {
    // Mount animation
    const timer = setTimeout(() => setIsMounted(true), 100);
    return () => clearTimeout(timer);
  }, []);

  useEffect(() => {
    if (scrollbarRef && scrollbarRef.current && isOpen) {
      const { width } = scrollbarRef.current.getBoundingClientRect();
      const isOverflow = 120 * amenitiesScenes.length > width;
      setIsScrollbarVisible(isOverflow);
    } else {
      setIsScrollbarVisible(false);
    }
  }, [isOpen, amenitiesScenes.length]);

  if (!isAmenityScene) return null;

  if (amenitiesScenes.length <= 0) return null;

  const toggleOpen = () => {
    setIsOpen(!isOpen);
  };

  const onScroll = () => {
    if (scrollbarRef.current) {
      scrollbarRef.current.scrollLeft += 9999;
    }
  };

  const getClassName = () => {
    if (!isMounted) return 'amenities-overview-list';
    return `amenities-overview-list ${isOpen ? 'open' : 'closed'}`;
  };

  return (
    <div className={getClassName()}>
      <button className="close-btn" onClick={toggleOpen}>
        {isOpen ? <CloseIcon color="#fff" /> : <GalleryIcon color="#fff" />}
      </button>
      {isScrollbarVisible && (
        <button className="scroll-btn" onClick={onScroll}>
          <ChervonDown color="#fff" />
        </button>
      )}
      <PerfectScrollbar
        containerRef={(ref) => (scrollbarRef.current = ref)}
        onXReachEnd={() => {
          setIsScrollbarVisible(false);
        }}
        onScrollLeft={() => {
          setIsScrollbarVisible(true);
        }}
      >
        {amenitiesScenes.map(({ previewImgUrl, title, _id, groupId }) => {
          return (
            <div
              className={`item ${sceneId === _id ? 'active' : ''}`}
              key={_id}
              onClick={() => selectSceneById(groupId, _id)}
            >
              <img src={previewImgUrl} alt={title} />
              <span>{title}</span>
            </div>
          );
        })}
      </PerfectScrollbar>
    </div>
  );
};
